import React from 'react';
import { observer } from 'mobx-react';
import { useTheme, Box, FormControl, IconButton, InputAdornment, OutlinedInput, Tooltip } from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import useData from './hooks';
import { NumericQcFieldName } from './const';
import { ValueFieldsTypesProps } from '50.quickConnect.Fields/FieldsTypes/types';
import QcTooltip from '50.quickConnect.Fields/QcTooltip';
import { NumericDesc } from '90.quickConnect.Models/models';
import { FieldMainBox, FlexRow, FlexMainBoxRow } from '50.quickConnect.Fields/styles';

const NumericQcField = ({
  field,
  updateDeclaration,
  labelSpan,
  setSelectedIndex,
  isReadOnly,
  flattenFields,
  labelClass,
}: ValueFieldsTypesProps) => {
  const numericDesc = field as NumericDesc;
  const { toolTip, id, fullPathId, isVertical } = numericDesc;
  const nameWithId = `${NumericQcFieldName}-${id}`;
  const { t, localValue, clearState, handleChange, requiredField, verifRequiredField, fieldFocused, onBlur } = useData(
    numericDesc,
    updateDeclaration,
    flattenFields,
  );

  const { breakpoints } = useTheme();

  return (
    <Box
      className={labelClass}
      id={`scrollToAnchor-${fullPathId}`}
      data-cy={nameWithId}
      sx={isVertical === false ? { ...FlexMainBoxRow(breakpoints), gap: 2 } : FieldMainBox(breakpoints)}
      onClick={() => (isReadOnly ? undefined : setSelectedIndex(fullPathId))}
    >
      <Box sx={isVertical === false ? { ...FlexRow, flex: 2, width: 'auto' } : FlexRow}>
        <Box component="span" sx={{ flex: 1 }}>
          {labelSpan}
        </Box>
        {toolTip && <QcTooltip parentId={id} tooltip={toolTip} />}
      </Box>
      <Box sx={isVertical === false ? { flex: 1 } : {}}>
        <OutlinedInput
          fullWidth
          inputRef={(input) => {
            if (input != null && verifRequiredField && requiredField?.fullPathId === fullPathId) {
              input.focus();
            } else if (
              input != null &&
              !verifRequiredField &&
              !requiredField &&
              fieldFocused &&
              fullPathId === fieldFocused
            ) {
              return input.focus();
            }
          }}
          onBlur={onBlur}
          data-cy={`${nameWithId}-input`}
          id={`${nameWithId}-input`}
          type={'number'}
          value={localValue}
          required
          onChange={handleChange}
          inputProps={{
            readOnly: isReadOnly,
            disabled: isReadOnly,
          }}
          placeholder={t("input_number'").toString()}
          endAdornment={
            <InputAdornment position="end">
              <Tooltip title={t('formlib_array_deleted_title').toString()}>
                <span>
                  <IconButton disabled={isReadOnly} data-cy={`${nameWithId}-clear`} edge="end" onClick={clearState}>
                    <ClearIcon />
                  </IconButton>
                </span>
              </Tooltip>
            </InputAdornment>
          }
        />
      </Box>
    </Box>
  );
};
export default observer(NumericQcField);
